export default "__VITE_ASSET___Ha2aiA___";